export default __webpack_public_path__ + "static/media/icon_document.6698f2a0.svg";